import apis from 'src/apis/apiRegister'

export const useApiSelector = () => {
    return apis;
}